import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  GROUPS_OF_ADMINS_MAIN_ROUTE_NAME,
  GROUPS_OF_ADMINS_PERMISSIONS,
} from '@modules/groups-of-admins/constants';
import {
  GROUPS_OF_ADMINS_EDIT_ROUTE_NAME,
  TRANSLATION_GROUPS_OF_ADMINS_EDIT,
} from '@modules/groups-of-admins/submodules/edit/constants';
import { getTranslationKeys } from '@modules/groups-of-admins/submodules/edit/translations';

export class GroupsOfAdminsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(GROUPS_OF_ADMINS_MAIN_ROUTE_NAME, {
      name: GROUPS_OF_ADMINS_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
      component: () => import('@modules/groups-of-admins/submodules/edit/pages/GroupsOfAdminEditPage/GroupsOfAdminEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_ADMINS_EDIT, getTranslationKeys);
  }
}
